module.exports = __webpack_public_path__ + "img/img03.af294afb.jpeg";